<template>
    <div class="day-view">
        <v-container>
            <v-row>
                <v-col v-if="showMorningCitation && morningCitation">
                    <CitationCard :citation="morningCitation"
                                  :show-sweet-text="showSweetText" />
                </v-col>
                <v-col cols="12" sm="4" md="3" xl="2">
                    <v-sheet>
                        <v-btn @click="selectDate"
                               class="w-100 mb-2"
                               color="lonely"
                               variant="flat">Выбрать день</v-btn>
                        <v-btn @click="selectDateRange"
                               class="w-100 mb-2"
                               color="lonely"
                               variant="flat">Выбрать период</v-btn>

                        <div class="w-100 mb-2 d-flex">
                            <div class="w-50">
                                <div class="mr-2">
                                    <v-btn @click="setPreviousDate"
                                           class="w-100"
                                           color="lonely"
                                           variant="flat">Назад</v-btn>
                                </div>
                            </div>
                            <div class="w-50">
                                <div class="ml-2">
                                    <v-btn @click="setNextDate"
                                           class="w-100"
                                           color="lonely"
                                           variant="flat">Вперёд</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-sheet>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <DaysTasksTable />
                </v-col>
            </v-row>

            <v-row v-if="showHabits">
                <v-col>
                    <HabitsTable />
                </v-col>
            </v-row>

            <v-row v-if="showEveningCitation && eveningCitation">
                <v-col>
                    <CitationCard :citation="eveningCitation"
                                  :show-sweet-text="showSweetText" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    import CitationCard from "@/components/client/CitationCard.vue";
    import DaysTasksTable from "@/components/client/day_tasks/DaysTasksTable.vue";
    import HabitsTable from "@/components/client/habits/HabitsTable.vue";

    export default {
        components: {
            CitationCard,
            DaysTasksTable,
            HabitsTable
        },

        data() {
            return {
            };
        },

        created() {
            this.$store.commit("setCurrentDateTime");
            this.$store.dispatch("loadUserGroups");
            this.$store.dispatch("loadClientSettings")
                .then(() => {
                    this.setDefaultDateRange();

                    this.loadCitations();
                    this.loadDaysTasks();
                    this.loadDaysResults();
                    this.loadHabits();
                });
        },

        computed: {
            ...mapState([
                "currentLocale",
                "currentDateTime", "selectedDateTime", "startDateTime", "endDateTime"
            ]),

            showSweetText() {
                return this.$store.state.clientSettings?.showSweetText ?? false;
            },
            showMorningCitation() {
                return this.$store.state.clientSettings?.showMorningCitation ?? false;
            },
            showEveningCitation() {
                return this.$store.state.clientSettings?.showEveningCitation ?? false;
            },
            showCitation() {
                return this.showMorningCitation || this.showEveningCitation;
            },

            showHabits() {
                return this.$store.state.clientSettings?.showHabits ?? false;
            },

            morningCitation() {
                return this.$store.state.morningCitation;
            },
            eveningCitation() {
                return this.$store.state.eveningCitation;
            },

            showDayResultText() {
                return this.$store.state.clientSettings?.showDayResultText ?? false;
            },
            showDayResultRating() {
                return this.$store.state.clientSettings?.showDayResultRating ?? false;
            },
            showDayResult() {
                return this.showDayResultText === true
                    || this.showDayResultRating === true;
            },

            countOfDaysBeforeCurrent() {
                return this.$store.state.clientSettings?.countOfDaysBeforeCurrent ?? 0;
            },
            countOfShowedDays() {
                return this.$store.state.clientSettings?.countOfShowedDays ?? 7;
            },

            isDateRange() {
                return this.startDateTime && this.endDateTime;
            },

            datesRange() {
                const startDate = this.isDateRange
                    ? this.startDateTime
                    : this.selectedDateTime
                        ? this.selectedDateTime
                        : this.currentDateTime.startOf("day");

                const endDate = this.isDateRange
                    ? this.endDateTime
                    : this.selectedDateTime
                        ? this.selectedDateTime
                        : this.currentDateTime.startOf("day");

                return {
                    startDate: startDate,
                    endDate: endDate
                };
            }
        },

        methods: {
            setDefaultDateRange() {
                const startDate = this.currentDateTime
                    .minus({ days: this.countOfDaysBeforeCurrent });

                if (this.countOfShowedDays > 1) {
                    const endDate = startDate
                        .plus({ days: this.countOfShowedDays - 1 });

                    this.$store.commit("setStartDateTime", startDate);
                    this.$store.commit("setEndDateTime", endDate);
                    this.$store.commit("setSelectedDateTime", null);
                } else if (this.countOfShowedDays === 1
                    && this.countOfDaysBeforeCurrent > 0) {
                    this.$store.commit("setStartDateTime", null);
                    this.$store.commit("setEndDateTime", null);
                    this.$store.commit("setSelectedDateTime", startDate);
                } else {
                    this.$store.commit("setStartDateTime", null);
                    this.$store.commit("setEndDateTime", null);
                    this.$store.commit("setSelectedDateTime", null);
                }
            },

            setPreviousDate() {
                if (!this.isDateRange) {
                    const nextDate = this.currentDateTime.minus({ days: 1 });

                    this.$store.commit("setSelectedDateTime", nextDate);
                } else {
                    const nextStartDate = this.startDateTime.minus({ days: this.countOfShowedDays });
                    const nextEndDate = this.endDateTime.minus({ days: this.countOfShowedDays });

                    this.$store.commit("setStartDateTime", nextStartDate);
                    this.$store.commit("setEndDateTime", nextEndDate);
                }
            },

            setNextDate() {
                if (!this.isDateRange) {
                    const nextDate = this.currentDateTime.plus({ days: 1 });

                    this.$store.commit("setSelectedDateTime", nextDate);
                } else {
                    const nextStartDate = this.startDateTime.plus({ days: this.countOfShowedDays });
                    const nextEndDate = this.endDateTime.plus({ days: this.countOfShowedDays });

                    this.$store.commit("setStartDateTime", nextStartDate);
                    this.$store.commit("setEndDateTime", nextEndDate);
                }
            },

            selectDate() {
                this.$store.commit("setShowDateDialog", true);
            },

            selectDateRange() {
                this.$store.commit("setShowDateRangeDialog", true);
            },

            loadDaysTasks() {
                this.$store.dispatch("loadDaysTasks");
            },

            loadDaysResults() {
                if (this.showDayResult) {
                    this.$store.dispatch("loadDaysResults");
                }
            },

            loadHabits() {
                if (this.showHabits) {
                    this.$store.dispatch("loadHabits");
                }
            },

            loadCitations() {
                if (this.showCitation) {
                    this.$store.dispatch("loadClientCitations");
                }
            }
        }
    };
</script>

<style lang="scss">
    .day-view {
    }
</style>